const planetCodeShort = {
  0: "Su",
  1: "Mo",
  2: "Me",
  3: "Ve",
  4: "Ma",
  5: "Ju",
  6: "Sa",
  7: "Ur",
  8: "Ne",
  9: "Pl",
  100: "Asc",
  101: "Ra",
  102: "Ke",
};

export default planetCodeShort;
